import request from "./../utils/request";

export const TABLE_API = {
    listTables: () => {
        return request({
            url: `/tables`,
            method: "get",
        }).then((response) => response.data);
    },
    getTableById: (id) => {
        return request({
            url: `/tables/${id}`,
            method: "get",
        }).then((response) => response.data);
    },
    createTable: (name, description, template) => {
        return request
            .put(`/tables`, {
                name,
                description,
                template,
            })
            .then((response) => response.data);
    },
    updateTable: (tableId, data) => {
        return request.post(`/tables/${tableId}`, data).then((response) => response.data);
    },
    deleteTable: (tableId) => {
        return request({
            url: `/tables/${tableId}`,
            method: "delete",
        }).then((response) => response.data);
    },
    listFields: (tableId) => {
        return request({
            url: `/tables/${tableId}/fields`,
            method: "get",
        }).then((response) => response.data);
    },
    createField: (tableId, data) => {
        return request({
            url: `/tables/${tableId}/fields`,
            method: "put",
            data,
        }).then((response) => response.data);
    },
    updateField: (tableId, fieldId, data) => {
        return request.post(`/tables/${tableId}/fields/${fieldId}`, data).then((response) => response.data);
    },
    deleteField: (tableId, fieldId) => {
        return request({
            url: `/tables/${tableId}/fields/${fieldId}`,
            method: "delete",
        }).then((response) => response.data);
    },

    listRecords: (tableId, filters, sort, cursor) => {
        return request
            .post(`/tables/${tableId}/records`, {
                filters,
                sort,
                cursor,
            })
            .then((response) => response.data);
    },
    createEmptyRecord: (tableId, filters, sort, cursor) => {
        return request(
            {
                url: `/tables/${tableId}/records/empty`,
                method: "put",
            },
            {}
        ).then((response) => response.data);
    },
    createRecordMulti: (tableId, values) => {
        return request.put(`/tables/${tableId}/records/multi`, { values }).then((response) => response.data);
    },
    updateRecord: (tableId, recordId, updatingFields) => {
        console.log("updateRecord", { tableId, recordId, updatingFields });
        return request
            .post(`/tables/${tableId}/records/${recordId}/update`, { updatingFields })
            .then((response) => response.data);
    },
    deleteRecordById: (tableId, recordId) => {
        return request.delete(`/tables/${tableId}/records/${recordId}`).then((response) => response.data);
    },
    deleteRecordsByIds: (tableId, recordIds) => {
        return request.post(`/tables/${tableId}/records/delete`, { recordIds }).then((response) => response.data);
    },

    // Duplicate records
    duplicateRecords: (tableId, recordIds) => {
        return request.post(`/tables/${tableId}/records/duplicate`, { recordIds }).then((response) => response.data);
    },

    // Update multiple records
    updateMultiRecord: (tableId, fieldId, recordIds, value) => {
        return request
            .put(`/tables/${tableId}/fields/${fieldId}/records`, { recordIds, value })
            .then((response) => response.data);
    },

    //#region VIEWS
    createView: (tableId, name, description, filters, sort, cursor, search, hiddenFields, lockedFields) => {
        return request
            .put(`/tables/${tableId}/views`, {
                name,
                description,
                filters,
                sort,
                cursor,
                search,
                hiddenFields,
                lockedFields,
            })
            .then((response) => response.data);
    },

    deleteView: (tableId, viewId) => {
        return request({
            url: `/tables/${tableId}/views/${viewId}`,
            method: "delete",
        }).then((response) => response.data);
    },

    updateView: (tableId, viewId, updatingFields) => {
        return request.post(`/tables/${tableId}/views/${viewId}`, updatingFields).then((response) => response.data);
    },

    listViews: (tableId) => {
        return request({
            url: `/tables/${tableId}/views`,
            method: "get",
        }).then((response) => response.data);
    },
    //#endregion
};
